import styled from '@emotion/styled'

import { breakpoints, NativeLink, palette, spacing, Text, typography } from 'main/ui'

export const RegionContainer = styled.div`
  background-color: ${palette.whiteDove};
  display: flex;
  flex-direction: column;
  justify-content: left;
  margin-bottom: ${spacing.majorScale(-1)}px;
  padding-top: ${spacing.majorScale(1)}px;
  width: 100%;
`

export const StyledHeading = styled(Text.withComponent('h1'))`
  font-size: 24px;
  font-weight: ${typography.fontWeight.bold};
  margin-bottom: ${spacing.majorScale(1)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: ${spacing.majorScale(2)}px;
    font-size: 30px;
  }
`

export const ReadMoreLink = styled(NativeLink)`
  align-items: center;
  display: flex;
  flex-direction: row;
`

export const StyledText = styled(Text)`
  @media (min-width: ${breakpoints.lg}px) {
    line-height: ${spacing.majorScale(3)}px;
  }
`

export const IconContainer = styled.div`
  color: ${palette.skyBlue2};
  margin-left: ${spacing.majorScale(1)}px;
  width: 16px;
`

export const TitleContainer = styled.div`
  margin-top: ${spacing.majorScale(-1)}px;
  margin-bottom: ${spacing.majorScale(1)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`
export const ContentContainer = styled.div`
  padding: ${spacing.majorScale(2)}px;

  @media (min-width: ${breakpoints.lg}px) {
    padding: ${spacing.majorScale(3)}px;
  }
`

export const ReadMoreLinkContainer = styled.div`
  margin: ${spacing.majorScale(2)}px 0;
`
